export const STEALTH_BUTTONS = "Stealth Buttons";
export const DARK_MODE = "Dark Mode";
export const HIDDEN_BURGER = "Hidden Burger";
export const HIDDEN_BAR = "Hidden Bar";
export const BEZEL_COLOR_LABEL = "Bezel Color";
export const URL_LABEL = "URL:";
export const PLACEHOLDER = "https://mokkup.netlify.app";
